import { HumanMaleIcon } from './HumanMaleIcon';

/**
 * author: Google
 * id 1369FF9C-0E57-4644-BE89-7B5EED0131B0
 * name human-male
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-male.svg
 * tags
 * - People / Family 
 */
export const ManIcon = HumanMaleIcon;
export default ManIcon